// extracted by mini-css-extract-plugin
module.exports = {"link":"AccountSettings_link__3w5w3","linkListItem":"AccountSettings_linkListItem__2gIWA","button":"AccountSettings_button__13XYO","text":"AccountSettings_text__avJAP"};